module.exports = __webpack_public_path__ + "media/anim_bus_oph.19482bc2.mp4";